import assetPath from '/app/xinglets/lebenslauf/components/frame/src/assets/anschreiben-logo-dark.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')